'use strict';

import addressFilter from './address';
import telFilter from './tel';
import reverseUrlFilter from './reverse-url';
import staticUrlFilter from './static-url';
import objectLengthFilter from './object-length';
import casesFilter from './cases';
import addSec from './add-sec';
import curUrl from './cur-url';
import yesno from './yesno';

const MODULE_NAME = 'daupler.filters';

var app = angular.module(MODULE_NAME, [
]);
app.filter('address', addressFilter);
app.filter('tel', telFilter);
app.filter('url', reverseUrlFilter);
app.filter('static', staticUrlFilter);
app.filter('objectLength', objectLengthFilter);
app.filter('cases', casesFilter);
app.filter('addSec', addSec);
app.filter('curUrl', curUrl);
app.filter('yesno', yesno);
// app.filter('reverse', reverseUrlFilter);

export default MODULE_NAME;
